import feathersClient, {makeServicePlugin, BaseModel} from '../../feathers-client'

class MobileApp extends BaseModel {
    constructor(data, options) {
        super(data, options)
    }

    // Required for $FeathersVuex plugin to work after production transpile.
    static modelName = 'MobileApp';

    // Define default properties here
    static instanceDefaults() {
        return {
            companyId: null,
            name: null,
            app_id: null,
            app_type: null,
            banner: null
        }
    }

    static setupInstance(data, {models}) {
        if (data.events) {
            data.events = data.events.map(e => new models.api.Event(e))
        } else {
            data.events = [];
        }
        return data
    }
}

const servicePath = 'mobile-apps';
const servicePlugin = makeServicePlugin({
    Model: MobileApp,
    service: feathersClient.service(servicePath),
    servicePath
});

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
    before: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    },
    after: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    },
    error: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    }
});

export default servicePlugin